import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'

import Card from '@mui/material/Card'
import Typography from '@mui/material/Typography'

import { OmniboxSearch } from './OmniboxSearch'

/**
 * Dashboard entry point for users who don't know where things are: a big search card with
 * everyday shortcuts. The same search is available on every page from the top bar.
 */
export function DashboardOmnibox(): JSX.Element {
  useLingui()
  return (
    <Card sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography component="h2" fontWeight={700} fontSize={{ xs: '1.15rem', sm: '1.35rem' }} color="#35374C" sx={{ mb: 2 }}>
        {t`What would you like to do?`}
      </Typography>
      <OmniboxSearch />
    </Card>
  )
}
